import filter from "ramda/src/filter";
import map from "ramda/src/map";
import pipe from "ramda/src/pipe";
import sum from "ramda/src/sum";
import {
  calculateTotalArea,
  castStringPropsToNumbers,
} from "../areas/houseArea";
import { isInitialized } from "../areas/baseArea";

export default pipe(
  filter(isInitialized),
  map(pipe(castStringPropsToNumbers, calculateTotalArea)),
  sum
);
